import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Imprintcharities = () => {
  const title = "{BRAND.short} picks its 18 charities that users will be able to vote for against each value."

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on June, 2025</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                As a values-driven network, {BRAND.domainLabel} empowers users to have
                a direct say in where a portion of their subscription fee goes
                each month. Users can vote for the charity they wish to support
                based on the platform&apos;s most trending value at that time.
              </p>

              <p>
                This initiative reflects {BRAND.domainLabel}&apos;s commitment to
                purposeful engagement, allowing the community to support causes
                that matter most to them in real time.
              </p>

              <p>
                Each month, users will be able to choose from 18 carefully
                selected charities—each aligned with one of {BRAND.domainLabel}&apos;s
                values—to receive a portion of the platform&apos;s monthly
                donation fund in line with the trending value for that month.
              </p>

              <p>
                The values are set out below together with a selection of
                aligned charities:
              </p>

              <ul>
                <li>
                  <strong>Life</strong> — Friends of the Earth, WaterAid,
                  Médecins Sans Frontières
                </li>
                <li>
                  <strong>Safety</strong> — Shelter, Oxfam, British Red Cross
                </li>
                <li>
                  <strong>Love</strong> — Respect, Humanity and Inclusion,
                  Samaritans
                </li>
                <li>
                  <strong>Laughter</strong> — Save the Children, UNICEF, PAPYRUS
                </li>
                <li>
                  <strong>Respect</strong> — WWF, Born Free, Humanimal Trust
                </li>
                <li>
                  <strong>Purpose</strong> — Room to Read, The Access Project,
                  Mental Health Innovations
                </li>
              </ul>

              <p>
                These charities alongside 3 additional charities that are
                important to the founders and The Buddyhood — Beat Eating
                Disorders, The British Heart Foundation, The National Literacy
                Trust — can also be voted for by {BRAND.domainLabel} users as part of
                the monthly #marathon on the platform, with the winner also
                receiving a donation from the platform.
              </p>

              <p>
                {BRAND.domainLabel} has no partnership agreements with the charities
                that have been chosen and the charities in no way endorse,
                support or are connected to {BRAND.domainLabel}. Donations will be made
                on a one-off basis with no guaranteed donation to any one
                charity. {BRAND.domainLabel} as a corporation does not choose the
                recipient charity, it is chosen by the users of the platform.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Imprintcharities;
